import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/email'

store.injectStore()
export { store }

export const useEmailSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useEmailActions = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)
